<template>
  <div class="order-list">
    <div class="patient-bgc"></div>
    <div class="patient-info patient-data">
      <van-row>
        <van-col span="24">
          <van-row class="content" align="center" justify="space-between">
            <van-col :span="22">
              <span class="placeholderColor">
                {{ patientInfo.patientName }}</span
              >
              <span class="placeholderColor" style="margin-left: 15px">
                就诊号：{{ patientInfo.visitNumber }}
              </span>
            </van-col>
            <van-col :span="2" class="sexImg">
              <img
                v-if="patientInfo.sex == 0"
                src="@/assets/img/sex-nv.png"
                alt=""
              />
              <img v-else src="@/assets/img/sex-nan.png" alt="" />
            </van-col>
          </van-row>
        </van-col>
        <van-col class="content" span="24">
          <van-row>
            <van-col :span="12">
              <span class="placeholderColor">就诊时间：</span>
              <span>
                {{ $moment(patientInfo.startTime).format("YYYY-MM-DD") }}
              </span>
            </van-col>
            <van-col :span="12">
              <span class="placeholderColor">就诊类型：</span>
              <span>{{ patientInfo.visitType == 1 ? "门诊" : "住院" }}</span>
            </van-col>
          </van-row>
        </van-col>
        <van-col class="content" span="24">
          <van-row>
            <van-col :span="12">
              <span class="placeholderColor">就诊医生：</span>
              <span>{{ patientInfo.doctorName }}</span>
            </van-col>
            <van-col :span="12">
              <span class="placeholderColor">就诊科室：</span>
              <span>{{ patientInfo.patientDeptName }}</span>
            </van-col>
          </van-row>
        </van-col>
        <van-col class="content" span="24">
          <van-row>
            <van-col span="24">
              <span class="placeholderColor">诊断：</span>
              <span>{{ patientInfo.diagnosisName }}</span>
            </van-col>
          </van-row>
        </van-col>
      </van-row>
    </div>
    <div class="order-content">
      <van-tabs @click="onClickTab" v-model:active="state.active" shrink>
        <van-tab
          v-for="item in state.paymentType"
          :key="item.id"
          :title="item.title"
        >
          <van-empty v-if="!state.orderList.length" description="暂无订单" />
          <van-pull-refresh
            v-else
            v-model="state.refreshing"
            @refresh="onRefresh"
          >
            <van-list
              v-model:loading="state.goodsLoading"
              :finished="state.goodsFinished"
              finished-text="没有更多了"
              @load="onLoad"
            >
              <van-row
                v-for="item in state.orderList"
                :key="item.id"
                class="order-container"
              >
                <van-col class="order-content-list" span="24">
                  <van-row align="center" justify="space-between">
                    <van-col span="7">
                      <span class="prescriptionName">肠内营养</span>
                    </van-col>
                    <van-col align="right" span="17">
                      <span class="placeholderColor">
                        处方编号：{{ item.medicalAdviceCode }}
                      </span>
                    </van-col>
                  </van-row>
                </van-col>
                <van-col class="order-content-list" span="24">
                  <van-row align="center" justify="space-between">
                    <van-col span="11">
                      <span class="placeholderColor">开嘱医生：</span>
                      <span>{{ item.createUser }}</span>
                    </van-col>
                    <van-col span="13">
                      <span class="placeholderColor">开具时间：</span>
                      <span>
                        {{ $moment(item.createTime).format("YYYY-MM-DD") }}
                      </span>
                    </van-col>
                  </van-row>
                </van-col>
                <van-col class="order-content-list" span="24">
                  <van-row align="center" justify="space-between">
                    <van-col span="11">
                      <span class="placeholderColor">支付金额：</span>
                      <span>￥{{ item.productAmount }}</span>
                    </van-col>
                    <van-col span="13">
                      <span class="placeholderColor">缴费状态：</span>
                      <span
                        :style="{
                          color: `${
                            item.orderStatus == 1
                              ? '#f34848'
                              : item.orderStatus == 3
                              ? ''
                              : '#247ffd'
                          }`,
                        }"
                      >
                        {{
                          [
                            "",
                            "待支付",
                            "",
                            "已支付",
                            "退款中",
                            "已退款",
                            "",
                            "已零退",
                          ][item.orderStatus]
                        }}
                      </span>
                    </van-col>
                  </van-row>
                </van-col>
                <van-col class="order-content-list goodsInfo" span="24">
                  <van-row align="center" justify="space-between">
                    <van-col class="title" span="24">
                      <span style="font-size: 16px">产品信息</span>
                    </van-col>
                    <van-col span="24">
                      <van-row
                        v-for="(goods, index) in item.consumeOrderGoodses"
                        :key="goods.id"
                        class="goods-list"
                      >
                        <van-col span="9">
                          <span>{{ index + 1 }}.{{ goods.goodsName }}</span>
                        </van-col>
                        <van-col span="11">
                          <span>{{ goods.productName }}</span>
                        </van-col>
                        <van-col align="right" span="4">
                          <span>
                            {{ goods.goodsQuantity
                            }}{{ goods.goodsUnitName }}</span
                          >
                        </van-col>
                      </van-row>
                    </van-col>
                  </van-row>
                </van-col>
                <van-col
                  align="right"
                  span="24"
                  class="order-content-list btn-content"
                >
                  <a href="tel:(020) 3868 8863">电话咨询</a>
                  <a @click="prescriptionDetails(item)">处方详情</a>
                  <a @click="payNow(item)">立即支付</a>
                </van-col>
              </van-row>
            </van-list>
          </van-pull-refresh>
        </van-tab>
      </van-tabs>
      <div
        @click="backEvent"
        :class="{ 'back-top-style': state.backTop }"
        class="back-top-content"
      >
        <van-icon name="back-top" />
      </div>
    </div>
    <!-- 详情弹层 -->
    <van-action-sheet
      class="order-details"
      van-action-sheet-max-height
      v-model:show="state.orderDetailsShow"
      title="详情"
    >
      <div>
        <span class="order-details-title"> 商品详情 </span>
        <div class="order-details-content">
          <van-row
            v-for="item in state.detailsData.consumeOrderGoodses"
            :key="item.id"
            class="order-details-list"
          >
            <van-col span="8">
              <span>{{ item.goodsName }}</span>
            </van-col>
            <van-col span="8">
              <span>{{ item.productName }}</span>
            </van-col>
            <van-col span="5">
              {{ `x ${item.goodsQuantity}${item.goodsUnitName}` }}
            </van-col>
            <van-col align="right" span="3">
              ￥{{ item.goodsTotalPrice }}
            </van-col>
          </van-row>
        </div>
        <van-row class="order-details-list">
          <van-col span="12">
            <span>合计金额</span>
          </van-col>
          <van-col align="right" span="12">
            ￥{{ state.detailsData.productAmount }}
          </van-col>
        </van-row>
        <div v-if="state.prescription" class="nutritional-parameters">
          <span class="order-details-title"> 营养参数 </span>
          <van-row class="order-details-list">
            <van-col span="12">
              <span>能量：{{ state.prescription.energy }} kcal</span>
            </van-col>
            <van-col align="right" span="12">
              <span>蛋白质：{{ state.prescription.protein }} g</span>
            </van-col>
          </van-row>
          <van-row class="order-details-list">
            <van-col span="12">
              <span>脂肪：{{ state.prescription.fat }} g</span>
            </van-col>
            <van-col align="right" span="12">
              <span>碳水化合物：{{ state.prescription.carbohydrate }} g</span>
            </van-col>
          </van-row>
        </div>
        <div class="usageAndDosage">
          <span class="order-details-title"> 用法用量 </span>
          <van-row class="order-details-list">
            <van-col span="24">
              <span>
                {{ JSON.parse(state.prescription.content).useageContent }}
              </span>
            </van-col>
          </van-row>
        </div>
        <div class="partingLine"></div>
        <div class="zeroRefund">
          <span class="order-details-title"> 零退记录 </span>
          <div v-for="item in state.prescriptionReturnses" :key="item.id">
            <div
              v-if="item.prescriptionReturnsDetailses.length"
              class="order-details-content"
            >
              <van-row
                v-for="returnses in item.prescriptionReturnsDetailses"
                :key="returnses.id"
                class="order-details-list"
              >
                <van-col span="10">
                  <span>{{ returnses.goodsName }}</span>
                </van-col>
                <van-col span="4">
                  {{ `x ${returnses.quantity}${returnses.goodsUnit}` }}
                </van-col>
                <van-col align="right" span="10">
                  ￥{{ returnses.subtotal }}
                </van-col>
              </van-row>
            </div>
            <van-row
              v-if="item.prescriptionReturnsDetailses.length"
              class="order-details-list"
            >
              <van-col span="12">
                <span>零退金额</span>
              </van-col>
              <van-col align="right" span="12">
                ￥{{ item.productAmountTotal }}
              </van-col>
            </van-row>
          </div>
        </div>
      </div>
    </van-action-sheet>
  </div>
</template>
<script setup>
import { onMounted, reactive, toRefs } from "vue";
import {
  gzhGetPatientCaseHistory,
  gzhOrderPage,
  gzhOrderInfo,
} from "@/api/order/order";
import { useRoute, useRouter } from "vue-router";
const route = useRoute();
const router = useRouter();
const state = reactive({
  refreshing: false,
  patientInfo: {},
  code: route.query.code,
  orderDetailsShow: false,
  active: 0,
  status: 1,
  paymentType: [
    {
      title: "已退款",
      id: 0,
      list: [],
    },
    {
      title: "已支付",
      id: 1,
      list: [],
    },
    {
      title: "未支付",
      id: 2,
      list: [],
    },
  ],
  paging: {
    pageSize: 10,
    pageNum: 1,
  },
  goodsLoading: false,
  goodsFinished: false,
  orderList: [],
  total: null,
  detailsData: {},
  prescription: {},
  prescriptionReturnses: {},
  backTop: false,
  type: route.query.type,
});

if (state.type == 1) {
  state.active = 2;
} else if (state.type == 2) {
  state.active = 1;
} else {
  state.active = 2;
}

// 获取患者信息
const queryPatientInfo = async () => {
  const caseHistoryId = route.query.caseHistoryId;
  let params = {
    code: state.code,
    caseHistoryId,
  };

  // 获取缓存个人信息
  const storageInfo = JSON.parse(localStorage.getItem("jndxOrderInfo"));
  // 判断是否重新进系统
  if (storageInfo && storageInfo.code == state.code) {
    params.caseHistoryId = storageInfo.caseHistoryId;
  }

  // 调用患者信息接口
  const data = await gzhGetPatientCaseHistory(params);
  state.patientInfo = data.data;
  state.goodsLoading = false;
  const infoData = {
    caseHistoryId: data.data.caseHistoryId,
    code: state.code,
  };
  localStorage.setItem("jndxOrderInfo", JSON.stringify(infoData));

  await queryPage();
};

queryPatientInfo();

// 获取订单列表分页
const queryPage = (type) => {
  const caseHistoryId = route.query.caseHistoryId;
  const params = {
    caseHistoryId: caseHistoryId || state.patientInfo.caseHistoryId,
    status: state.type * 1 || state.status,
  };

  state.goodsLoading = true;
  if (params.caseHistoryId) {
    gzhOrderPage(Object.assign(params, state.paging)).then((v) => {
      const { data } = v;
      if (type == 1) {
        state.orderList = [];
      }

      data.records.forEach((value) => {
        state.orderList.push(value);
      });
      state.goodsLoading = false;
      state.refreshing = false;
      state.goodsFinished = false;
      state.total = data.total;
      if (!type) {
        prescriptionDetails();
      }
    });
  }
};

// 点击标签
const onClickTab = (val) => {
  state.paging.pageNum = 1;
  if (val == 1) {
    state.status = 2;
    state.type = 2;
  } else if (val == 2) {
    state.status = 1;
    state.type = 1;
  } else if (val == 0) {
    state.status = 3;
    state.type = 3;
  }
  backEvent();
  queryPage(1);
};

// 上拉加载
const onLoad = () => {
  state.goodsLoading = false;
  state.paging.pageNum += 1;
  if (state.total && state.orderList.length >= state.total) {
    state.goodsFinished = true;
  } else {
    queryPage(2);
  }
};
// 下拉刷新
const onRefresh = () => {
  state.paging.pageNum = 1;
  state.goodsFinished = false;
  queryPage(1);
};
// 处方详情
const prescriptionDetails = (item) => {
  let orderId = route.query.orderId;
  let params = {};
  if (orderId) {
    params = { orderId };
  } else {
    params = { orderId: item.id };
  }
  gzhOrderInfo(params).then((v) => {
    const { data } = v;
    const { consumeOrder, prescription, prescriptionReturnses } = data;
    state.detailsData = consumeOrder;
    state.prescription = prescription;
    state.prescriptionReturnses = prescriptionReturnses;
    if (params.orderId) {
      state.orderDetailsShow = true;
      console.log(state.orderDetailsShow);
    }
  });
};

// 立即支付
const payNow = (item) => {
  router.push(`/pre/jndx?adviceCode=${item.medicalAdviceCode}&category=2`);
  console.log(item);
};
// 处理回到顶部
onMounted(() => {
  const vanTabs = document.querySelector(".van-tabs__content");
  vanTabs.addEventListener("scroll", (event) => {
    if (event.target.scrollTop >= 500) {
      state.backTop = true;
    } else {
      state.backTop = false;
    }
  });
});

// 回到顶部
function backEvent() {
  const vanTabs = document.querySelector(".van-tabs__content");
  let num = (vanTabs.scrollTop / 40).toFixed(0);
  let myTimer = setInterval(() => {
    vanTabs.scrollTop -= num;
    if (vanTabs.scrollTop <= 0) {
      vanTabs.scrollTop = 0;
      state.backTop = false;
      clearInterval(myTimer);
    }
  }, 10);
}

const { patientInfo } = toRefs(state);
</script>
<style lang="scss" scoped>
.partingLine {
  border-top: 1px solid #999;
  margin-top: 10px;
}
// 回到顶部出现
.back-top-style {
  transform: scale(1) !important;
}
::v-deep .van-tabs__nav {
  background: transparent !important;
  justify-content: center;
  .van-tab {
    flex: inherit;
    margin-right: 15px;
    .van-tab__text {
      font-size: 16px;
    }
  }
  // .van-tab:first-of-type {
  //   margin-right: 20px;
  // }
  .van-tabs__line {
    background: #1d7bff;
    height: 6px;
    width: 20px;
  }
}

.order-list {
  height: 100%;
  background: #eff2f5;
  display: flex;
  flex-direction: column;
  .van-skeleton {
    background: #fff;
    padding: 20px;
    flex: 1 1 auto;
  }
  .van-empty {
    flex: 1 1 auto;
    margin-top: -40%;
  }
  .patient-bgc {
    position: fixed;
    width: 100%;
    height: 130px;
    top: 0;
    left: 0;
    background: linear-gradient(#1d7bfe 60%, #f5f6fa);
    border-bottom-right-radius: 20px;
    border-bottom-left-radius: 20px;
  }

  ::v-deep .order-details {
    max-height: 90%;
    height: 90%;
    padding: 0 16px;
    &-content {
      border-bottom: 1px dashed #999;
    }
    &-title {
      vertical-align: middle;
      padding-bottom: 10px;
      display: inline-block;
    }
    &-title::before {
      content: "";
      display: inline-block;
      height: 18px;
      width: 4px;
      background: #1d7bfe;
      margin-right: 5px;
      vertical-align: middle;
    }
    &-list {
      padding: 10px 0 10px 15px;
    }
  }
  .patient-info {
    background: #fff;
    padding: 0 10px 10px 10px;
    border-radius: 10px;
    & {
      .content {
        padding: 10px 0;
      }
    }
    .placeholderColor {
      color: #999;
    }
    .sexImg {
      img {
        width: 75%;
      }
    }
  }
  .patient-data {
    position: relative;
    margin: 0 12px;
    margin-top: 12%;
  }
  .usageAndDosage {
    margin-top: 20px;
    .order-details-title {
      padding: 0;
    }
  }
  .zeroRefund {
    margin-top: 20px;
  }
  .nutritional-parameters {
    margin-top: 10px;
  }
  .order-content {
    display: flex;
    flex: 1 1 auto;
    padding: 0 12px;
    margin-top: 5%;
    flex-direction: column;
    overflow: hidden;
    padding-bottom: 20px;
    ::v-deep .van-list__finished-text {
      margin-bottom: 20px;
    }
    // 回到顶部
    .back-top-content {
      width: 50px;
      height: 50px;
      border-radius: 50%;
      background: #1d7bfe;
      bottom: 5%;
      right: 5%;
      position: absolute;
      text-align: center;
      display: flex;
      justify-content: center;
      align-items: center;
      transform: scale(0);
      transition: all 0.3s;
      .van-icon-back-top {
        color: #fff;
        font-size: 25px;
        font-weight: bold;
      }
    }
    .van-pull-refresh {
      overflow: visible;
    }
    .van-tabs {
      display: flex;
      flex-direction: column;
      width: 100%;

      ::v-deep .van-tabs__wrap {
        margin-bottom: 5px;
      }
      ::v-deep .van-tabs__content {
        display: flex;
        height: 68vh;
        overflow-y: auto;
        .van-tab__pane {
          width: 100%;
          margin-top: 10px;
          display: flex;
          flex-direction: column;
          .order-container {
            background: #fff;
            @extend .patient-info;
            margin-bottom: 10px;
            .order-content-list {
              padding: 10px 0;
              .prescriptionName {
                font-weight: bold;
                font-size: 16px;
              }
            }
            .goodsInfo {
              border-bottom: 1px dashed #eee;
              padding-bottom: 20px;
              .goods-list {
                padding: 10px 0 0 10px;
              }
            }
            .btn-content {
              padding-top: 20px;
              a {
                font-size: 16px;
                margin-right: 20px;
                color: #247ffd;
              }
              a:last-of-type {
                margin: 0;
                color: #f34848;
              }
            }
          }
        }
      }
    }
  }
}
</style>
